var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.03,
    height: 39.66,
    viewBox: "0 0 41.03 39.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6.68 4.13 0 23.96 13.83 39.66 27.43 18.44 6.68 4.13",
    fill: "#fad2e1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "41.03 15.7 34.35 35.53 13.83 39.66 20.52 19.83 27.43 11.13 41.03 15.7",
    fill: "#fbdfea"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.52 19.83 41.03 15.7 27.2 0 6.68 4.13 20.52 19.83",
    fill: "#fdedf3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance3);
export default __webpack_public_path__ + "static/media/entrance_3.8aa938310a2fc6c59c165fe67df3d2ed.svg";
export { ForwardRef as ReactComponent };